<template>
    <div>
            <b-row class="pt-5">
                <b-col md="11" lg="10" offset-lg="1" class="pb-4 text-left">
                    <b-card-group deck>
                        <b-card title="Riepilogo complessivo" img-src="img/all_system.png" img-alt="Cent" img-top>
                            <b-card-text>
                                <div class="p-1">Totale impianti NuBe: <b>{{this.num_all_plants}}</b></div>
                                <div class="p-1">Total  impianti NuBe senza dispositivi: <b>{{this.num_empty_plants}}</b></div>
                                <div class="p-1">Totale impianti NuBe attivi: <b>{{this.num_active_plants}}</b></div>
                                <ul>  
                                    <li class="pb-1 pl-3">Italia: <b>{{this.num_italy_plants}}</b> </li>
                                    <li class="pb-1 pl-3">Estero: <b>{{this.num_foreign_plants}}</b> </li>        
                                </ul>                      
                                <div class="p-1">Dispositivi totali in impianti NuBe: <b>{{this.num_lamps_all}}  </b></div>
                                <div class="p-1">Lampade di emergenza in impianti NuBe: <b>{{this.num_lamps_all_emergency}}  </b></div>
                                <div class="p-1">Lampade di illuminazione in impianti NuBe: <b>{{this.num_lamps_all_lighting}}  </b></div>
                                <div class="p-1">Altri dispositivi in impianti NuBe: <b>{{this.num_lamps_all_other}}  </b></div>
                            </b-card-text>
                        </b-card>
                                    
                        <b-card title="Riepilogo impianti centralizzati" img-src="img/cent_system.png" img-alt="Bluetooth" img-top>
                            <b-card-text>
                                <div class="p-1">Impianti centralizzati: <b> {{this.num_cent_plants}} </b></div> 
                                <div class="p-1">Impianti centralizzati vuoti: <b> {{this.num_cent_empty_plants}} </b></div>  
                                <div class="p-1">Impianti centralizzati attivi: <b> {{this.num_cent_active_plants}} </b></div>
                                <ul>
                                <li class="pb-1 pl-3">NuBe PRO: <b>{{this.num_cent_pro_plants}}</b> </li>
                                <li class="pb-1 pl-3">NuBe BASIC: <b>{{this.num_cent_basic_plants}}</b> </li>        
                                <li class="pb-1 pl-3">Italia: <b>{{this.num_cent_italy_plants}}</b> </li>
                                <li class="pb-1 pl-3">Estero: <b>{{this.num_cent_foreign_plants}}</b> </li>    
                                </ul>

                                <div class="p-1">Numero centrali: <b> {{this.num_cu}}</b> -> lampade: <b>{{this.num_lamps_all_cent}}</b></div>
                                <div class="p-1">Numero centrali Cablecom: <b> {{this.num_cablecom_cu}} </b> -> lampade: <b>{{this.num_lamps_cablecom}}</b></div>
                                <div class="p-1">Numero centrali Logica: <b> {{this.num_logica_cu}} </b> -> lampade: <b>{{this.num_lamps_logica}}</b></div>
                                <div class="p-1">Numero centrali Logica FM: <b> {{this.num_logicafm_cu}} </b> -> lampade: <b>{{this.num_lamps_logicafm}}</b></div>
                                <ul>
                                    <li class="pb-1 pl-3">Emergenza: <b>{{this.num_lamps_logicafm_emergency}}</b> </li>
                                    <li class="pb-1 pl-3">Illuminazione: <b>{{this.num_lamps_logicafm_lighting}}</b> </li>   
                                    <li class="pb-1 pl-3">Altri dispositivi: <b>{{this.num_lamps_logicafm_other}}</b> </li>     
                                </ul>    
                                <div class="p-1">Numero centrali Sicuro: <b> {{this.num_sicuro_cu}} </b> -> lampade: <b>{{this.num_lamps_sicuro}}</b></div>
                                <ul>
                                    <li class="pb-1 pl-3">Sicuro230: <b> {{ this.num_sicuro_230 }}</b></li>
                                    <li class="pb-1 pl-3">Sicuro24: <b> {{ this.num_sicuro_24 }}</b></li>
                                    <li class="pb-1 pl-3">Altri dispositivi: </li>
                                    <ul>
                                        <li class="pb-1 pl-3">Ak: <b>{{ this.num_sicuro_ak }}</b></li>
                                        <li class="pb-1 pl-3">Ak esterni: <b>{{ this.num_sicuro_ak_ext }}</b></li>
                                        <li class="pb-1 pl-3">Charger: <b>{{ this.num_sicuro_charger }}</b></li>
                                        <li class="pb-1 pl-3">Switch11kW: <b>{{ this.num_sicuro_switch }}</b></li>
                                        <li class="pb-1 pl-3">Lssa: <b>{{ this.num_sicuro_lssa }}</b></li>
                                    </ul>
                                </ul>

                                <br>
                                <!-- <div class="p-1">Impianti centralizzati solo emergenza: <b> {{this.emergencyPlants()}} </b></div>
                                <ul>
                                    <li class="pb-1 pl-3">Lampade in impianti solo emergenza: <b>{{this.emergencyPlantsLamps()}}</b> </li>
                                </ul>   

                                <div class="p-1">Impianti centralizzati solo illuminazione: <b> {{this.lightingPlants()}} </b></div>
                                <ul>
                                    <li class="pb-1 pl-3">Lampade in impianti solo illuminazione: <b>{{this.lightingPlantsLamps()}}</b> </li>
                                </ul>   

                                <div class="p-1">Impianti centralizzati illuminazione + emergenza: <b> {{this.num_cent_active_plants - this.emergencyPlants() - this.lightingPlants()}} </b></div>
                                <ul>
                                    <li class="pb-1 pl-3">Lampade emergenza in impianti misti: <b>{{this.emergencyMixedPlantsLamps()}}</b> </li>
                                    <li class="pb-1 pl-3">Lampade illuminazione in impianti misti: <b>{{this.cuLightingLampsAllPlants() - this.lightingPlantsLamps()}}</b> </li>
                                </ul>

                                <br>
                                <div class="p-1">Lampade in impianti centralizzati: <b> {{this.cuLampsAllPlants()}} </b></div>
                                <div class="p-1">Lampade di emergenza in impianti centralizzati: <b>{{this.cuEmergencyLampsAllPlants()}}  </b></div>
                                <div class="p-1">Lampade di illuminazione in impianti centralizzati: <b>{{this.cuLightingLampsAllPlants()}}  </b></div>
                                <div class="p-1">Sensori, interfacce, moduli I/O in impianti centralizzati: <b>{{this.cuLampsAllPlants()- this.cuEmergencyLampsAllPlants() - this.cuLightingLampsAllPlants()}}  </b></div>-->
                            </b-card-text>
                        </b-card> 

                        <b-card title="Riepilogo impianti bluetooth" img-src="img/bluetooth_system.png" img-alt="Bluetooth" img-top>
                            <b-card-text>
                                <div class="p-1">Impianti bluetooth: <b> {{this.num_ble_plants}} </b></div> 
                                <div class="p-1">Impianti bluetooth vuoti: <b> {{this.num_ble_empty_plants}} </b></div>
                                <div class="p-1">Impianti bluetooth attivi: <b> {{this.num_ble_active_plants}} </b></div>
                                <ul>
                                    <li class="pb-1 pl-3">Italia: <b>{{this.num_ble_italy_plants}}</b> </li>
                                    <li class="pb-1 pl-3">Estero: <b>{{this.num_ble_foreign_plants}}</b> </li>        
                                </ul>     
                                <div class="p-1">Lampade in impianti bluetooth: <b> {{this.num_lamps_all_ble}} </b></div>
                                <div class="p-1">Gateways in impianti bluetooth: <b> {{this.num_gateways_ble}} </b></div>
                            </b-card-text>
                        </b-card>

                    
                    </b-card-group>
                </b-col>
            </b-row>
       
    </div>

</template>

<script>

import {showAt, hideAt} from 'vue-breakpoints'


export default {
    name: 'NTOSUmmaryCards',
    components: {
        hideAt, 
        showAt,
    },    
    props: [
        'plants'
    ],
    data() {
        return {
            userId: null,
            pageloading: true,
            authorized: false,
            dataLoaded: false,

            num_all_plants:0,
            num_cent_plants:0,
            num_cent_empty_plants:0,
            num_cent_active_plants:0,
            num_cent_italy_plants:0,
            num_cent_foreign_plants:0,
            num_cent_pro_plants:0,
            num_cent_basic_plants:0,

            num_cent_plants_only_emergency:0,
            num_cent_plants_only_lighting:0,
            num_cent_plants_only_mixed:0,
            
            num_ble_plants:0,
            num_ble_empty_plants:0,
            num_ble_active_plants:0,
            num_ble_italy_plants:0,
            num_ble_foreign_plants:0,

            num_empty_plants:0,
            num_active_plants:0,
            num_basic_plants:0,
            num_pro_plants:0,
            num_italy_plants:0,
            num_foreign_plants:0,

            num_lamps_all:0,
            num_lamps_all_emergency:0,
            num_lamps_all_lighting:0,
            num_lamps_all_other:0,

            num_lamps_all_cent:0,
            num_lamps_all_cent_emergency:0,
            num_lamps_all_cent_lighting:0,
            num_lamps_all_cent_other:0,
            num_lamps_cablecom:0,
            num_lamps_logica:0,
            num_lamps_logicafm:0,
            num_lamps_logicafm_emergency:0,
            num_lamps_logicafm_lighting:0,
            num_lamps_logicafm_other:0,
            num_lamps_sicuro:0,           
            num_lamps_all_ble:0,
            num_gateways_ble:0,

            num_lamps_lighting_in_lighting:0,
            num_lamps_lighting_in_mixed:0,
            num_lamps_emergency_in_emergency:0,
            num_lamps_emergency_in_mixed:0,
            num_lamps_emergency_ble:0,
            num_lamps_lighting_ble:0,            

            num_cu:0,
            num_cablecom_cu:0,
            num_logica_cu:0,
            num_logicafm_cu:0,
            num_sicuro_cu:0,
            num_gatewayble:0,
            
            num_sicuro_230:0,
            num_sicuro_24:0,
            num_sicuro_ak:0,
            num_sicuro_ak_ext:0,
            num_sicuro_charger:0,
            num_sicuro_switch:0,
            num_sicuro_lssa:0,
            all_cu:[]
        }
    },
   
    mounted() {
        console.log("PLANTS IN SUMMARY CARDS: ",this.plants);
        this.creaDatiRiepilogo();
    },

    computed: {

        //cent plants
        centAllPlants() {
            return this.plants.filter((item) => {
                    return (item.technology!='bluetooth')
            })
        },

        activeCentPlants() {
            return this.plants.filter((item) => {
                    return (item.technology!='bluetooth' && (item.controlunits!=null && item.controlunits.length>0))
            })
        }

        },  
    
    methods: {
        creaDatiRiepilogo()
        {
            this.plants.forEach((item) => {
                
                this.num_all_plants++;
                
                //centralized plants
                if(item.technology!='bluetooth') this.num_cent_plants++;
                if(item.technology!='bluetooth' && (item.controlunits==null || item.controlunits.length==0)) this.num_cent_empty_plants++;
                if(item.technology!='bluetooth' && (item.controlunits!=null && item.controlunits.length>0)) this.num_cent_active_plants++;
                if(item.technology!='bluetooth' && (item.controlunits!=null && item.controlunits.length>0) && item.address.country=="IT") this.num_cent_italy_plants++;
                if(item.technology!='bluetooth' && (item.controlunits!=null && item.controlunits.length>0) && item.address.country!="IT") this.num_cent_foreign_plants++;
                if(item.technology!='bluetooth' && (item.controlunits!=null && item.controlunits.length>0) && item.plant_type=="basic") this.num_cent_basic_plants++;
                if(item.technology!='bluetooth' && (item.controlunits!=null && item.controlunits.length>0) && item.plant_type=="pro") this.num_cent_pro_plants++;
                
                //ble plants
                if(item.technology=='bluetooth') this.num_ble_plants++;
                if(item.technology=='bluetooth' && (item.ble_lamps==null || item.ble_lamps.length==0)) this.num_ble_empty_plants++;
                if(item.technology=='bluetooth' && (item.ble_lamps!=null && item.ble_lamps.length>0)) this.num_ble_active_plants++;
                if(item.technology=='bluetooth' && (item.ble_lamps!=null && item.ble_lamps.length>0) && item.address.country=="IT") this.num_ble_italy_plants++;
                if(item.technology=='bluetooth' && (item.ble_lamps!=null && item.ble_lamps.length>0) && item.address.country!="IT") this.num_ble_foreign_plants++;
                
                //num cent in centralized plants
                if(item.technology!='bluetooth')
                {
                    if(item.controlunits!=null && item.controlunits.length>0)
                    {
                        for(var k=0;k<item.controlunits.length;k++)
                        {
                            this.num_cu++;
                            var cu=item.controlunits[k];
                            
                            if(cu.cutype=="cablecom")
                            {     
                                this.num_cablecom_cu++;
                                if(cu.num_lamp_found!=null && cu.num_lamp_found>0)
                                {
                                    this.num_lamps_cablecom=this.num_lamps_cablecom+cu.num_lamp_found;
                                    this.num_lamps_all_cent_emergency=this.num_lamps_all_cent_emergency+cu.num_lamp_found;
                                }
                            }
                            if(cu.cutype=="logica")
                            {     
                                this.num_logica_cu++;
                                if(cu.num_lamp_found!=null && cu.num_lamp_found>0)
                                {
                                    this.num_lamps_logica=this.num_lamps_logica+cu.num_lamp_found;
                                    this.num_lamps_all_cent_emergency=this.num_lamps_all_cent_emergency+cu.num_lamp_found;
                                }
                            }
                            
                            if(cu.cutype=="logicafm")
                            {     
                                this.num_logicafm_cu++;
                                if(cu.num_lamp_found!=null && cu.num_lamp_found>0)
                                {      
                                    //emergency fm
                                    if(item.cus_details[k] && item.cus_details[k].lamps_id!=null && item.cus_details[k].lamps_id.length>0)
                                    {
                                        this.num_lamps_logicafm_emergency=this.num_lamps_logicafm_emergency+ item.cus_details[k].lamps_id.length;
                                        this.num_lamps_all_cent_emergency=this.num_lamps_all_cent_emergency+ item.cus_details[k].lamps_id.length;
                                    }

                                    //lighting fm
                                    if(item.cus_details[k] && item.cus_details[k].lamps_illum_id!=null && item.cus_details[k].lamps_illum_id.length>0)
                                    {
                                       this.num_lamps_logicafm_lighting=this.num_lamps_logicafm_lighting+ item.cus_details[k].lamps_illum_id.length;
                                       this.num_lamps_all_cent_lighting=this.num_lamps_all_cent_lighting+ item.cus_details[k].lamps_illum_id.length;    
                                    } 
                                    
                                    //other fm
                                    if(item.cus_details[k] && item.cus_details[k].lamps_altro_id!=null && item.cus_details[k].lamps_altro_id.length>0)
                                    {
                                        this.num_lamps_logicafm_other=this.num_lamps_logicafm_other+ item.cus_details[k].lamps_altro_id.length;
                                        this.num_lamps_all_cent_other=this.num_lamps_all_cent_other+ item.cus_details[k].lamps_altro_id.length;        
                                    }
                                }
                            }
                            
                        }
                    }

                    //Inserito lampade sicuro
                    if(item.cus_details!=null && item.cus_details.length>0)
                    {
                        for(k=0; k<item.cus_details.length; k++)
                        {
                            cu=item.cus_details[k];

                            if (cu.cu_type=="sicuro")
                            {     
                                this.num_sicuro_cu++;
                                console.log("Sicuro: #" + this.num_sicuro_cu + " datai: ", item);
                                if (cu.cu_system == '24') {
                                    this.num_sicuro_24++;
                                } else {
                                    this.num_sicuro_230++;
                                }
                                if (cu.num_lamp_found!=null && cu.num_lamp_found>0)
                                {
                                    this.num_lamps_sicuro=this.num_lamps_sicuro+cu.num_lamp_found;
                                    this.num_lamps_all_cent_emergency=this.num_lamps_all_cent_emergency+cu.num_lamp_found;
                                }
                                if (cu.ak_index != null) {
                                    this.num_sicuro_ak += cu.ak_index.length;
                                }
                                if (cu.ak_index_ext != null) {
                                    this.num_sicuro_ak_ext += cu.ak_index_ext.length;
                                }
                                if (cu.charger_index != null) {
                                    this.num_sicuro_charger += cu.charger_index.length;
                                }
                                if (cu.switch11kw_index != null) {
                                    this.num_sicuro_switch += cu.switch11kw_index.length;
                                }
                                if (cu.lssa_index != null) {
                                    this.num_sicuro_lssa += cu.lssa_index.length;
                                }
                            }
                        }
                    }
                }
                //ble lamps
                else
                {
                    if(item.ble_lamps!=null)
                    {   
                        this.num_lamps_all_ble=this.num_lamps_all_ble+item.ble_lamps.length;
                    }
                    
                    if(item.cus_details!=null && item.cus_details.length>0)
                    {   
                        this.num_gateways_ble=this.num_gateways_ble+item.cus_details.length;
                    }
                }


            });
            
            //impianti
            this.num_empty_plants=this.num_ble_empty_plants+this.num_cent_empty_plants;
            this.num_active_plants=this.num_ble_active_plants+this.num_cent_active_plants;
            this.num_italy_plants=this.num_ble_italy_plants+this.num_cent_italy_plants;
            this.num_foreign_plants=this.num_ble_foreign_plants+this.num_cent_foreign_plants;

            //lampade su tutti gli impianti            
            this.num_lamps_all_emergency=this.num_lamps_all_ble+this.num_lamps_all_cent_emergency;    
            this.num_lamps_all_lighting =this.num_lamps_all_cent_lighting;    
            this.num_lamps_all_other =this.num_lamps_all_cent_other;
            //aggiungo anche i dispositivi SICURO
            this.num_lamps_all_other += (this.num_sicuro_ak + this.num_sicuro_ak_ext + this.num_sicuro_charger + this.num_sicuro_switch + this.num_sicuro_lssa);
            this.num_lamps_all=this.num_lamps_all_emergency+this.num_lamps_all_lighting+this.num_lamps_all_other;
            
            //lampade su centrali fm
            this.num_lamps_logicafm=this.num_lamps_logicafm_emergency+this.num_lamps_logicafm_lighting+this.num_lamps_logicafm_other; 
            
            //lampade centralizzate
            this.num_lamps_all_cent=this.num_lamps_cablecom+this.num_lamps_logica+this.num_lamps_logicafm+this.num_lamps_sicuro; 

        },


        cuAllPlants()
        {
            var allCu=[];
            for(var k=0;k<this.centAllPlants.length;k++)
                if(this.getCuPlant(this.centAllPlants[k])!=null)
                {
                    allCu=allCu.concat(this.getCuPlant(this.centAllPlants[k]));
                }
            return allCu;    
        },

        cuLampsAllPlants()
        {
            var allCuLamps=0;
            for(var k=0;k<this.cuAllPlants().length;k++)
            {
                if(this.cuAllPlants()[k].num_lamp_found!=null)
                {
                    allCuLamps=allCuLamps + this.cuAllPlants()[k].num_lamp_found;
                }
            }
            return allCuLamps;    
        },

        cuEmergencyLampsAllPlants()
        {
            var allCuEmergencyLamps=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_id!=null)
                        {
                            allCuEmergencyLamps=allCuEmergencyLamps+ cus.lamps_id.length;
                        }
                    }
                
            }
            return allCuEmergencyLamps;    
        },

        cuLightingLampsAllPlants()
        {
            var allCuLightingLamps=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_illum_id!=null)
                        {
                            allCuLightingLamps=allCuLightingLamps+ cus.lamps_illum_id.length;
                        }
                    }
                
            }
            return allCuLightingLamps;    
        },

        cuOthersAllPlants()
        {
            var allCuOthers=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_altro_id!=null)
                        {
                            allCuOthers=allCuOthers+ cus.lamps_altro_id.length;
                        }
                    }
                
            }
            return allCuOthers;    
        },

        emergencyPlants()
        {
            var emergencyPlants=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                var cuEm=0;
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_id!=null)
                        {
                            if(cus.lamps_id.length>0 && (cus.lamps_illum_id==null || cus.lamps_illum_id.length==0))
                            cuEm++;
                        }
                    }
                if(cuEm>0)
                 emergencyPlants++;    
                
            }
            return emergencyPlants;    
        },

        emergencyPlantsLamps()
        {
        
            var emergencyPlantLamps=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_id!=null && cus.lamps_id.length>0 && (cus.lamps_illum_id==null || cus.lamps_illum_id.length<=0))
                        {
                            emergencyPlantLamps=emergencyPlantLamps+ cus.lamps_id.length;
                        }
                    }
                
            }
            return emergencyPlantLamps;    
        
        },

        lightingPlants()
        {
            var lightingPlants=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                var cuIll=0;
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_illum_id!=null)
                        {
                            if(cus.lamps_illum_id.length>0 && (cus.lamps_id==null || cus.lamps_id.length<=0))
                            cuIll++;
                        }
                    }
                if(cuIll>0)
                lightingPlants++;      
                
            }
            return lightingPlants;    
        },

        lightingPlantsLamps()
        {
        
            var lightingPlantLamps=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_illum_id!=null && (cus.lamps_id==null || cus.lamps_id.length<=0))
                        {
                            lightingPlantLamps=lightingPlantLamps+ cus.lamps_illum_id.length;
                        }
                    }
                
            }
            return lightingPlantLamps;    
        
        },

        mixedPlants()
        {
            var mixedPlants=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {   
                var cuMix=0;
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_id!=null && cus.lamps_illum_id!=null)
                        {
                            if(cus.lamps_id.length>0 && cus.lamps_illum_id.length>0)
                            cuMix++;
                        }
                    }
                if(cuMix>0)
                 mixedPlants++;      
                
            }
            return mixedPlants;    
        },

        emergencyMixedPlantsLamps()
        {
        
            var emergencyMixedPlantLamps=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_id!=null && cus.lamps_illum_id!=null && cus.lamps_illum_id.length>0)
                        {
                            emergencyMixedPlantLamps=emergencyMixedPlantLamps+ cus.lamps_id.length;
                        }
                    }
                
            }
            return emergencyMixedPlantLamps;    
        
        },

        // emergencyMixedPlantsLamps()
        // {
        
        //     var emergencyMixedPlantLamps=0;
        //     for(var k=0;k<this.activeCentPlants.length;k++)
        //     {
        //         for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
        //             {
        //                 var cus=this.activeCentPlants[k].cus_details[n];
        //                 if(cus.lamps_id!=null && cus.lamps_illum_id!=null && cus.lamps_illum_id.length>0)
        //                 {
        //                     emergencyMixedPlantLamps=emergencyMixedPlantLamps+ cus.lamps_id.length;
        //                 }
        //             }
                
        //     }
        //     return emergencyMixedPlantLamps;    
        
        // },

        bleLampsAllPlants()
        {
            var allBleLamps=[];
            for(var k=0;k<this.bleAllPlants.length;k++)
                if(this.bleAllPlants[k].ble_lamps!=null)
                {
                    allBleLamps=allBleLamps.concat(this.bleAllPlants[k].ble_lamps);
                }
            return allBleLamps;    
        },

        cuGatewayAllPlants()
        {
            return this.cuAllPlants().filter((item) => {
                    return (item.cutype=="blegateway")
            })
        },

        getCuPlant(plant) {
            if(plant!=null)
            {
                if (plant.controlunits != null) 
                  return plant.controlunits;
            }
        },

      
        getTipoImpianto(imp) {
            if (imp!=null)
            {
                if(imp.technology == "bluetooth") 
                {
                    return "Bluetooth";
                }
                else {
                    return "Centralizzato";
                }  
            } 
        },

        selectedMonth(value) {
            console.log("selected month",value);
            this.graficoPeriodo = value.month; 
        }
    }
    

}
</script>